import { LogLevel, PulseStorage, SharedConfigurations } from '@pulse/common';

export class LoggerService {
    private logLevel: LogLevel = LogLevel.Warn;

    private readonly KEY_LOG_LEVEL: string = 'log_level';

    constructor(
        private storage: PulseStorage,
        private config: SharedConfigurations,
    ) {}

    level(): LogLevel {
        if (typeof this.logLevel !== 'number') {
            this.logLevel =
                Number(this.storage.get(this.KEY_LOG_LEVEL) || 0) || this.config.logLevel || 0;
        }

        return this.logLevel;
    }

    setLevel(level: LogLevel): void {
        this.logLevel = level;
        this.storage.set(this.KEY_LOG_LEVEL, String(level));
    }

    enabled(level: LogLevel): boolean {
        const logLevel = this.level();

        return level <= logLevel;
    }

    error(service: string, ...messages: any[]) {
        this.print(service, LogLevel.Error, messages);
    }

    warn(service: string, ...messages: any[]) {
        this.print(service, LogLevel.Warn, messages);
    }

    info(service: string, ...messages: any[]) {
        this.print(service, LogLevel.Info, messages);
    }

    verbose(service: string, ...messages: any[]) {
        this.print(service, LogLevel.Verbose, messages);
    }

    private print(service: string, level: LogLevel, messages: any[]): void {
        if (!this.enabled(level)) {
            return;
        }

        switch (level) {
            case LogLevel.Error:
                // eslint-disable-next-line no-console
                console.log(`${service}:`);
                console.error(...messages);
                break;
            case LogLevel.Warn:
                console.warn(`${service}: `, ...messages);
                break;
            case LogLevel.Info:
                console.info(`${service}: `, ...messages);
                break;
            case LogLevel.Verbose:
                // eslint-disable-next-line no-console
                console.log(`${service}: `, ...messages);
                break;
        }
    }
}
